import { ICoreServiceModel } from '../common/model/ICoreServiceModel';

export interface IUserDataModel extends ICoreServiceModel {
  userId: string;
  level: UserDataLevel;
  totalScore: number;
  maxScore: number;
  toNextLevelScore: number;
  levelThresholds: {
    junior: number;
    middle: number;
    senior: number;
  };
}

export enum UserDataLevel {
  SENIOR = 'senior',
  MIDDLE = 'middle',
  JUNIOR = 'junior',
}
